import {ActionItem} from "./list_actions_model";
import * as React from "react";
import {ItemsRenderer} from "../results_panel"
import PopupItemText from "../popup_item_text"

const MORE_ID = 'moreSeparatorId';
enum MoreItemsState {
    HIDDEN,
    SHOWING,
    SHOWN
}

const _highlight_text = (text, terms) => maxkir.highlight_text(text, terms, 'start');

export default class ActionItemsRenderer implements ItemsRenderer {

    private _items: ActionItem[];
    private readonly _selectedIndex: number;
    private readonly _moreItemsState: MoreItemsState;
    private readonly _filterTerms: string[];

    private _break_list: boolean = false;
    private _separatorIdx: number = 0;
    private _selectedElementId: string;
    private _visibleCountIdx: number = 0;
    private _rendered: JSX.Element[];

    constructor(items: ActionItem[], selectedIndex: number,
                moreItemsState: MoreItemsState, filterTerms: string[]) {
        this._items = items;
        this._selectedIndex = selectedIndex;
        this._moreItemsState = moreItemsState;
        this._filterTerms = filterTerms;
    }

    getSelectedElementId() {
        this.renderItems();
        return this._selectedElementId;
    }

    getVisibleCount() {
        this.renderItems();
        return this._visibleCountIdx;
    }

    renderItems() {
        if (!this._rendered) {
            this._rendered = this._items.map((item) => this.render_item(item));
        }
        return this._rendered;
    }

    render_item(item: ActionItem) {
        let classes = "searchEverywhere__li searchEverywhere__liAction";

        if (item.id === "---") {
            const key = "separator_" + (this._separatorIdx++);
            classes += " separator"
            if (this._break_list) {
                return <li key={key} className={classes + " searchEverywhere__li--hiddenMore"}/>;
            }
            return <li key={key} className={classes}/>;
        }


        const selected = this._selectedIndex === this._visibleCountIdx;

        if (item.id === "---more---") {
            if (this._moreItemsState === MoreItemsState.SHOWN) {
                return null;
            }

            if (!this._break_list) {
                this._break_list = true;

                this._visibleCountIdx++;
                if (selected) {
                    this._selectedElementId = MORE_ID;
                    classes += " selected";
                }
                if (this._moreItemsState === MoreItemsState.SHOWING) {
                    classes += ' searchEverywhere__moreSeparator--showing'
                }

                return <li className={classes + ' searchEverywhere__moreSeparator'}
                           id={MORE_ID} key={MORE_ID}>{I18N('js_more')}</li>
            }
            return null;
        }

        const rendered = maxkir.CommonRender.format_for_rendering(item.text, true, null);
        if (rendered) {
            if (this._break_list) {
                classes += this._moreItemsState === MoreItemsState.SHOWING ?
                    ' searchEverywhere__li--showingMore' :
                    ' searchEverywhere__li--hiddenMore';
            }

            if (!cv_commands.can_run(item.id, item.tag)) {
                if (!this._filterTerms.length) {
                    // Do not show disabled items when filter is not active
                    return null;
                }

                classes += ' disabled';
            }

            if (!this._break_list) {
                this._visibleCountIdx++;
            }

            let shortcut = cv_commands.shortcut(item.id, item.shortcut);
            let text = cv_commands.text(item.id, item.text);
            if (this._filterTerms.length) {
                text = _highlight_text(text, this._filterTerms);
                const terms = this._filterTerms.filter((x) => x !== "<");
                shortcut = _highlight_text(shortcut, terms); // should not try to highlight < in <kbd>
            }
            let title = item.title || '';
            title = title.replace(/'/, "&#39;");
            const id = `ss_cmd_${item.id}`
            const icon = 'searchEverywhere__icon' + (item.icon ? ` ${item.icon}` : '');

            if (selected) {
                this._selectedElementId = id;
                classes += " selected";
            }

            return <li className={classes} id={id} data-list-id={item.id} key={id}
                       data-list-tag={item.tag} title={title}>
                <span className={icon}/>

                <PopupItemText text={text} filterTerms={this._filterTerms}/>

                <span className='searchEverywhere__shortcut'
                      dangerouslySetInnerHTML={{__html: shortcut}}
                />
            </li>;
        }


    }
}
